<template>
  <div class="document-image" :class="{ hover: state === 'editor' }">
    <dropzone @upload="update" v-if="!part.content && state === 'editor'"></dropzone>
    <span v-if="part.content && state !== 'preview'"><i class="icon icon-edit" @click="resetDropzone()"></i></span>
    <img :src="part.content" v-if="part.content" :class="{ 'preview': state === 'preview' }">
  </div>
</template>

<script>
  export default {
    props: ['part', 'state'],
    methods: {
      update(upload) {
        this.part.content = upload.url;
        this.$emit('update', { part: this.part, value: upload.url });
      },
      resetDropzone() {
        if (this.state === 'editor') {
          this.part.content = null;
          this.$emit('update', { part: this.part, value: null });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  .dropzone {
    border: 5px dashed $green;
    padding: 40px;

    &:hover {
      background-color: $eggshell;
    }
  }

  .document-image {
    position: relative;
    span {
      z-index: 1001;
      display: none;
      position: absolute;
      left: 50%;
      top: 50%;
      background: $green;
      border-radius: 100px;
      width: 50px;
      height: 50px;
      margin-left: -25px;
      margin-top: -25px;
      text-align: center;
      color: $white;
      padding-top: 13px;
      padding-right: 4px;
      &:hover {
        cursor: pointer;
      }
    }
    // Scope hover effect to editor only
    &.hover {
      &:hover {
        span {
          display: block;
          &:hover {
            background: darken($green, 10%);
          }
        }
        img {
          opacity: 0.3;
          &.preview {
            opacity: 1;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// image.vue?08c12135